import React from 'react';
import Menu from '@material-ui/core/Menu';
import { Paper } from '@material-ui/core';
import styles from './filters.module.scss';

const FiltersDropdown = (props): JSX.Element => {
  const { label, selectedItem, icon } = props;
  const {
    filterInteractiveElement, menuOpen, filterMenuList, hasSelectedItemsState, iconUnion,
  } = styles;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [isMenuOpen, setMenuOpen] = React.useState<boolean>(false);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMenuOpen(false);
  };

  return (
        <>
            <button className={
                `${filterInteractiveElement} 
                 ${isMenuOpen ? menuOpen : ''}
                 ${selectedItem && !isMenuOpen ? hasSelectedItemsState : ''}
               `}
                    onClick={(event) => handleMenuClick(event)}>
                <span>{selectedItem || label}</span>
                { icon && <i className={`ic ${icon} ${iconUnion}`}/> }
                { !icon && <i className={`ic icon-dropdown-chevron-${isMenuOpen ? 'up' : 'down'}`}/>}
            </button>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                autoFocus={false}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                elevation={2}
                marginThreshold={50}
                MenuListProps={{ disablePadding: true }}
            >
                <Paper elevation={0} onClick={handleClose}>
                    <ul className={filterMenuList}>
                        {props.children}
                    </ul>
                </Paper>
            </Menu>
        </>);
};

export default FiltersDropdown;
